import React from 'react'
import { Icon, SplitContentContainer } from 'src/chrome'
import { FlexColumn } from 'src/styled'
import planContentStyles from '../PlanContentsGrid/planContentsGrid.module.scss'

type WaysToSendProps = {
  screenWidth?: number
}

const WaysToSend: React.FC<WaysToSendProps> = props => {
  const { screenWidth } = props
  return (
    <div className={planContentStyles.featureGridContainer}>
      <div className={planContentStyles.featureGrid}>
        <h1>2 Ways to Send:</h1>
        <SplitContentContainer
          withSplitBorder={false}
          containerStyle={{ width: '100%' }}
          stack={(screenWidth || 1000) <= 800}
        >
          <FlexColumn
            style={{
              width: '50%',
              alignItems: 'center',
              margin: '15px auto',
            }}
          >
            <div style={{ width: 80, marginBottom: 20 }}>
              <Icon
                icon={'CATALOGCARD'}
                color={'#9C9CA0'}
                viewBox={'0 0 32 32'}
                size={80}
              />
            </div>
            <h5 style={{ color: '#6A6A6A' }}>Heartfelt Prompting Cards</h5>
            <div>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                  marginTop: '9px',
                }}
              >
                A card with a unique heartfelt message sent to a single
                recipient with an immediate send date.
              </p>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                  marginTop: '9px',
                }}
              >
                Subject to fair use policy.
              </p>
            </div>
          </FlexColumn>
          <FlexColumn
            style={{
              width: '50%',
              alignItems: 'center',
              margin: '15px auto',
            }}
          >
            <div style={{ width: 80, marginBottom: 20 }}>
              <Icon
                icon={'GROUP'}
                color={'#9C9CA0'}
                viewBox={'0 0 60 30'}
                size={80}
              />
            </div>
            <h5 style={{ color: '#6A6A6A' }}>System Sends</h5>
            <div>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                  marginTop: '9px',
                }}
              >
                • A card sent to multiple recipients
              </p>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                }}
              >
                • A card set with a future send date to one or more recipients
              </p>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                }}
              >
                • A card sent with Campaigns and Multiple-Touch Campaigns
              </p>
            </div>
          </FlexColumn>
        </SplitContentContainer>
      </div>
    </div>
  )
}

export default WaysToSend
